import { gql } from '@apollo/client';

export const EljurExchangeCodeMutation = gql`
    mutation EljurExchangeCode($regionalCenterId: ID!, $code: String!, $state: String!) {
        eljurExchangeCode(regionalCenterId: $regionalCenterId, code: $code, state: $state) {
            accessToken
            refreshToken
            redirectUrl
        }
    }
`;
